import { lazyRouteComponent } from '@tanstack/react-router';
import { V9_JOURNEY_PATH } from '@/services/constants';

const JOURNEY_PAGES: Record<string, { path: string; component: any; title: string }> = {
  ADDRESS: {
    path: `/${V9_JOURNEY_PATH}/address`,
    component: lazyRouteComponent(() => import('@/pages/Address')),
    title: 'Address',
  },
  CHECKING_ELIGIBILITY: {
    path: `/${V9_JOURNEY_PATH}/checking-eligibility`,
    component: lazyRouteComponent(() => import('@/pages/CheckingEligibility')),
    title: 'Checking Eligibility',
  },
  INFO: {
    path: `/${V9_JOURNEY_PATH}/info`,
    component: lazyRouteComponent(() => import('@/pages/Info')),
    title: 'Info',
  },
  CONTACT: {
    path: `/${V9_JOURNEY_PATH}/contact`,
    component: lazyRouteComponent(() => import('@/pages/Contact')),
    title: 'Contact',
  },
  SETTING_UP_CASE: {
    path: `/${V9_JOURNEY_PATH}/setting-up-case`,
    component: lazyRouteComponent(() => import('@/pages/SettingUpCase')),
    title: 'Setting Up Case',
  },
  SIGN_FINAL: {
    path: `/${V9_JOURNEY_PATH}/sign`,
    component: lazyRouteComponent(() => import('@/pages/SignV9')),
    title: 'Sign',
  },
  EXPERIAN: {
    path: `/${V9_JOURNEY_PATH}/credits-report`,
    component: lazyRouteComponent(() => import('@/pages/CreditReport/credits-report')),
    title: 'Credits Report',
  },
  EQUIFAX: {
    path: `/${V9_JOURNEY_PATH}/credit-report`,
    component: lazyRouteComponent(() => import('@/pages/CreditReport/credit-report')),
    title: 'Credit Report',
  },
  EQUIFAX_STEALTH: {
    path: `/${V9_JOURNEY_PATH}/credit-report-s`,
    component: lazyRouteComponent(() =>
      import('@/pages/CreditReport/credit-report').then((m) => ({
        default: () => <m.default stealthMode />,
      }))
    ),
    title: 'Credit Report',
  },
  VIEW_THRU: {
    path: `/${V9_JOURNEY_PATH}/creditv-report`,
    component: lazyRouteComponent(() => import('@/pages/CreditReport/creditv-report')),
    title: 'Credit Report',
  },
  EQUIFAX_INFO: {
    path: `/${V9_JOURNEY_PATH}/credit-report-eg`,
    component: lazyRouteComponent(() => import('@/pages/CreditReport/CreditHistoryEquifax')),
    title: 'Equifax Report',
  },
  FINISH_SCREEN: {
    path: `/${V9_JOURNEY_PATH}/submit-claim`,
    component: lazyRouteComponent(() => import('@/pages/FinishScreen')),
    title: 'Finish Screen',
  },
  FINISH: {
    path: `/${V9_JOURNEY_PATH}/finish`,
    component: lazyRouteComponent(() => import('@/pages/FinalScreen')),
    title: 'Final Screen',
  },
  OTP: {
    path: `/${V9_JOURNEY_PATH}/otp`,
    component: lazyRouteComponent(() => import('@/components/Otp')),
    title: 'OTP',
  },
  LUMINATE_IDV: {
    path: `/${V9_JOURNEY_PATH}/questions`,
    component: lazyRouteComponent(() => import('@/pages/LuminateIdv')),
    title: 'Luminate IDV',
  },
  ID_VERIFY: {
    path: `/${V9_JOURNEY_PATH}/id-verify`,
    component: lazyRouteComponent(() => import('@/pages/OnfidoVerification')),
    title: 'Identity Verification',
  },
  ALREADY_FILED: {
    path: `/${V9_JOURNEY_PATH}/already-filed`,
    component: lazyRouteComponent(() => import('@/pages/AlreadyFiled')),
    title: 'Already Filed',
  },
  NO_AGREEMENTS_FOUND: {
    path: `/${V9_JOURNEY_PATH}/no-agreements-found`,
    component: lazyRouteComponent(() => import('@/pages/CreditReport/NoAgreementsFoundPage')),
    title: 'No Agreements Found',
  },
  SHARE_LINK: {
    path: `/${V9_JOURNEY_PATH}/share-link`,
    component: lazyRouteComponent(() => import('@/pages/CreditReport/ShareLinkPage')),
    title: 'Share Link',
  },
};

// Kept for compatibility — preloading is now handled by the router's loader
export const preloadJourneyChunks = () => {};

export default JOURNEY_PAGES;
